var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeLightLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#222222",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5714 10C19.4669 10 18.5714 10.8954 18.5714 12V14.306C17.6022 14.4446 16.8571 15.2782 16.8571 16.2857V20C16.8571 21.1046 17.7526 22 18.8571 22H25.1429C26.2474 22 27.1429 21.1046 27.1429 20V16.2857C27.1429 15.2782 26.3978 14.4446 25.4286 14.306V12C25.4286 10.8954 24.5331 10 23.4286 10H20.5714ZM23.7143 14.2857H20.2857V12.7143C20.2857 12.162 20.7334 11.7143 21.2857 11.7143H22.7143C23.2666 11.7143 23.7143 12.162 23.7143 12.7143V14.2857ZM22 16.8571C21.5266 16.8571 21.1429 17.2409 21.1429 17.7143V18.5714C21.1429 19.0448 21.5266 19.4286 22 19.4286C22.4734 19.4286 22.8571 19.0448 22.8571 18.5714V17.7143C22.8571 17.2409 22.4734 16.8571 22 16.8571Z",
    fill: "#222222",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLightLocked);
export default __webpack_public_path__ + "static/media/we-light-locked.6bdf6c5d60336aea82ea0cfdc39604ce.svg";
export { ForwardRef as ReactComponent };